import { useQuery } from '@tanstack/react-query';
import api, { DocumentSignFileResponse } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface UseDocumentFilesReturn {
  files: DocumentSignFileResponse[];
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useDocumentFiles(envelopeId: string | undefined): UseDocumentFilesReturn {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: envelopeId ? queryKeys.documentSign.files(envelopeId) : ['documentSign-files-noop'],
    queryFn: () => {
      if (!envelopeId) return Promise.resolve({ files: [] });
      return api.listDocumentSignFiles(envelopeId);
    },
    enabled: !!envelopeId,
  });

  return {
    files: data?.files ?? [],
    loading: isLoading,
    error: error instanceof Error ? error.message : error ? 'Failed to load files' : null,
    refresh: () => {
      refetch();
    },
  };
}
